import { useFormState } from "react-final-form";
import { useTranslation } from "react-i18next";
import { shallowEqual } from "react-redux";
import { useSelector } from "src/store";

import { selectProvisionings } from "@dashboard/provisioning/store/selectors";
import { Row, SectionDescription } from "@dashboard/shared/styles";
import { useTheme } from "@mui/material/styles";
import { ControlledSelectField } from "@shared/form/SelectField/SelectField";

import {
    CollapsibleProvider,
    CollapsibleSectionDetails,
    CollapsibleSectionSummary,
    CollapsibleSectionTitle,
    useCollapsiblePersistence,
} from "../../shared/components/CollapsibleSection";
import { Provisioning } from "../types";

export const Screen = () => {
    const theme = useTheme();
    const { t } = useTranslation(["pages"]);
    const { value, onChange } = useCollapsiblePersistence("provisioningPage.collapsedSections", "Screen");
    const provisionings = useSelector(selectProvisionings, shallowEqual);
    const { values: parentFormValues } = useFormState<Partial<Provisioning>>();

    const screenRotation = parentFormValues?.settings?.screenRotation;
    const summary = screenRotation
        ? t("pages:provisioningPage.section.screen.summary", { degrees: screenRotation * 90 })
        : undefined;

    return (
        <CollapsibleProvider initialValue={value} onChange={onChange}>
            <CollapsibleSectionSummary>
                <CollapsibleSectionTitle summary={summary}>
                    {t("pages:provisioningPage.section.screen.title")}
                </CollapsibleSectionTitle>
            </CollapsibleSectionSummary>
            <CollapsibleSectionDetails>
                <SectionDescription>{t("pages:provisioningPage.section.screen.description")}</SectionDescription>
                <Row style={{ paddingBottom: 0, marginTop: theme.spacing(4) }}>
                    <ControlledSelectField
                        label={t("pages:provisioningPage.input.screenRotation.caption")}
                        name="settings.screenRotation"
                        disabled={!provisionings.length}
                        options={[0, 90, 180, 270].map((item, index) => ({
                            label: `${item}°`,
                            value: index,
                        }))}
                        fullWidth
                    />
                </Row>
            </CollapsibleSectionDetails>
        </CollapsibleProvider>
    );
};
